var _rect, _path, _path2, _g, _rect2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgEnforceArrowSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 50,
    viewBox: "0 0 36 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 50,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1267 -2364C-1267 -2365.1 -1266.1 -2366 -1265 -2366H4337C4338.1 -2366 4339 -2365.1 4339 -2364V14887C4339 14888.1 4338.1 14889 4337 14889H-1265C-1266.1 14889 -1267 14888.1 -1267 14887V-2364Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-1265 -2365H4337V-2367H-1265V-2365ZM4338 -2364V14887H4340V-2364H4338ZM4337 14888H-1265V14890H4337V14888ZM-1266 14887V-2364H-1268V14887H-1266ZM-1265 14888C-1265.55 14888 -1266 14887.6 -1266 14887H-1268C-1268 14888.7 -1266.66 14890 -1265 14890V14888ZM4338 14887C4338 14887.6 4337.55 14888 4337 14888V14890C4338.66 14890 4340 14888.7 4340 14887H4338ZM4337 -2365C4337.55 -2365 4338 -2364.55 4338 -2364H4340C4340 -2365.66 4338.66 -2367 4337 -2367V-2365ZM-1265 -2367C-1266.66 -2367 -1268 -2365.66 -1268 -2364H-1266C-1266 -2364.55 -1265.55 -2365 -1265 -2365V-2367Z",
    fill: "black",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6009_32173)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1084,
    y: -2064,
    width: 1920,
    height: 10969,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6438 13.188L-1.6091e-06 13.188L-1.47312e-07 36.812L12.6438 36.812L12.6438 50L36 25.0033L12.6438 -5.52677e-07L12.6438 13.188Z",
    fill: "#DC3A1A"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -1083.5,
    y: -2063.5,
    width: 1919,
    height: 10968,
    rx: 1.5,
    stroke: "black",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6009_32173"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1084,
    y: -2064,
    width: 1920,
    height: 10969,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgEnforceArrowSmall);
export default __webpack_public_path__ + "static/media/img-enforce-arrow-small.2412524996893e8a23a06fff07143a82.svg";
export { ForwardRef as ReactComponent };